<template>
  <div class="month-picker__container">
    <div class="month-picker__year">
      <button type="button" @click="changeYear(-1)">
        <svg
          viewBox="0 0 16 16"
          width="1em"
          height="1em"
          focusable="false"
          role="img"
          aria-label="chevron left"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi-chevron-left b-icon bi"
        >
          <g transform="translate(0 -0.5)">
            <g>
              <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              ></path>
            </g>
          </g>
        </svg>
      </button>
      <p>{{ year }}</p>
      <button type="button" @click="changeYear(+1)">
        <svg
          viewBox="0 0 16 16"
          width="1em"
          height="1em"
          focusable="false"
          role="img"
          aria-label="chevron left"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi-chevron-left b-icon bi"
        >
          <g transform="translate(0 -0.5)">
            <g transform="translate(8 8) scale(-1 1) translate(-8 -8)">
              <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              ></path>
            </g>
          </g>
        </svg>
      </button>
    </div>
    <div class="month-picker">
      <div
        v-for="(month, monthIndex) in months"
        :key="month"
        :class="{
          selected: currentMonthIndex === monthIndex
        }"
        class="month-picker__month"
        @click="selectMonth(monthIndex, true)"
      >
        {{ month }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MonthPicker",
  props: ["defaultMonth", "defaultYear", "noDefault"],
  emits: ["change", "input", "change-year"],
  data: () => ({
    currentMonthIndex: null,
    year: 0,
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ]
  }),
  mounted() {
    this.year = this.getCurrentAdjustedDateTime().getFullYear();
    if (this.defaultYear) {
      this.year = this.defaultYear;
    }

    if (this.defaultMonth) {
      this.selectMonth(this.defaultMonth - 1);
    } else if (!this.noDefault) {
      this.selectMonth(0);
    }
  },
  methods: {
    onChange() {
      if (!Number.parseInt(this.year)) {
        this.year =
          this.defaultYear || this.getCurrentAdjustedDateTime().getFullYear();
      }

      this.$emit("change", this.date);
    },
    selectMonth(index, input = false) {
      const isAlreadySelected = this.currentMonthIndex === index;
      if (isAlreadySelected) {
        return;
      }

      this.currentMonthIndex = index;
      this.onChange();

      if (input) {
        this.$emit("input", this.date);
      }
    },
    changeYear(value) {
      this.year += value;
      this.onChange();
    }
  },
  computed: {
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    currentMonth: function() {
      if (this.currentMonthIndex !== null) {
        return this.months[this.currentMonthIndex];
      }

      return null;
    },
    date: function() {
      const month = this.months.indexOf(this.currentMonth) + 1;
      return `${this.year}/${
        month < 10 ? month.toString().padStart(2, "0") : month
      }/15`;
    }
  },
  watch: {
    defaultMonth(newVal) {
      this.currentMonthIndex = newVal;
    },
    defaultYear(newVal) {
      this.year = newVal;
    }
  }
};
</script>

<style>
.month-picker__container {
  min-width: 200px;
  width: 200px;
  position: relative;
  font-size: 14px;
}

.month-picker {
  box-sizing: border-box;
  flex: 1;
  width: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /*box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);*/
  font-family: sans-serif;
  /*border-radius: 5px;*/
  overflow: hidden;
  padding: 1px 4px 4px;
}

.month-picker__year {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.month-picker__year p {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  flex: 1;
  padding: 4px;
  margin: 0;
}

.month-picker__year input:focus {
  border: 1px solid #16aaff;
}

.month-picker__year button {
  background: transparent;
  width: 2rem;
  font-size: 1rem;
  border-radius: 5px;
  outline: none;
  border: 0;
  z-index: 2;
  color: black;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
}

.month-picker__year button:hover {
  background-color: #646a7a;
  color: white;
}

.month-picker__year button:focus {
  outline: none;
}

.month-picker__year button:first-child {
  left: 10px;
}

.month-picker__year button:last-child {
  right: 10px;
}

.month-picker__month {
  flex-basis: 33.333%;
  padding: 7px 5px;
  cursor: pointer;
  text-align: center;
  font-size: 13px;
  /*border: 1px solid rgba(245, 245, 245, 0.75);*/
  transition: all 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
  /*background-color: #fefefe;*/
  user-select: none;
}

.month-picker .month-picker__month:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.month-picker__month.selected {
  background-color: #55b0f2;
  color: #ffffff;
  /*border-radius: 5px;*/
  /*box-shadow: inset 0 0 3px #3490d2, 0px 2px 5px rgba(85, 176, 242, 0.2);*/
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

@media only screen and (max-width: 768px) {
  .month-picker__container {
    width: 100%;
  }
}
</style>
